/**
 * Transfer PATCH yanıtını store'a yansıtır.
 * Backend tarih değişince bağlı personel servislerini syncedPersonelServices ile döner.
 */
export function applyTransferUpdateToStore(store, responseData) {
  const transfer = responseData?.transfer;
  if (!transfer) {
    return;
  }

  store.UpdateTransfer(transfer);

  const syncedServices = responseData?.syncedPersonelServices;
  if (!Array.isArray(syncedServices)) {
    return;
  }

  syncedServices.forEach((service) => {
    if (service?.id) {
      store.UpdatePersonelService(service);
    }
  });
}
